import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND;

const axiosInstanceFromCode = axios.create({
  baseURL: backendUrl,
});

axiosInstanceFromCode.interceptors.request.use((config) => {
  config.params = config.params || {};
  config.headers["Accept-Language"] = ["es-ES,es;q=0.9,en"];
  return config;
});

axiosInstanceFromCode.interceptors.response.use((response) => {
  return response;
});

export default axiosInstanceFromCode;
